import { rejectAll } from '../../GoalResolvers';
import { State } from '../../State';

export function idle(state: State): State {
  state.whenIdle?.resolve();
  // Nothing should get rejected because we should have settled everything by now.
  const goalResolvers = rejectAll(state.goalResolvers, 'Idling');
  return {
    ...state,
    goalResolvers,
    nextTask: undefined,
    whenIdle: undefined,
  };
}
